import * as Yup from 'yup';

const UpdateEmailSchema = Yup.object().shape({
    newEmail: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
    newEmailConfirm: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
});

export default UpdateEmailSchema;
